export default "__VITE_ASSET__DRMCoutX__"